import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import store from './store';

import Game from './game';
import audio from './scripts/audio';
import translate from './scripts/translate';
import eventHub from './scripts/eventHub';
import {
  getLang,
  sendGAEvent,
  inApp,
  isLogged,
} from './scripts/utils';

Vue.config.productionTip = false;

Vue.prototype.$game = new Game();
Vue.prototype.$audio = audio;
Vue.prototype.$translate = (key) => translate(key, getLang());
Vue.prototype.$sendEvent = sendGAEvent;
Vue.prototype.$eventHub = eventHub;
Vue.prototype.$inApp = inApp();
Vue.prototype.$isLogged = isLogged();

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app');
